/*jshint esversion:6  */
import React from "react";
import Select from "react-select";
import Toaster from "toastr";
import Datepicker from "react-datepicker";
import FloatInput from "../../common/floatInput";
import ArbiterApi from "../../../api/ArbiterApi";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Constants from "../../../configurations/constants";
import Permissions from "../../../configurations/permissions";
import Messages from "../../../configurations/messages";
import Util from "../../../util/util";
// import DisputesParamsDropdown from "./DisputesParamsDropdown";
import SelectDropdown from "./DisputeSelectDropdown";

class DisputesFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      logCode: "",
      category: null,
      region: null,
      status: null,
      searchConcerns: null,
      regions: [],
      categories: [],
      statuses: [],
      acquirers: [],
      issuers: [],
      merchants: [],
      acquirerCode: null,
      issuerCode: null,
      merchantCode: null,
      searchConcernss: [{
        label: "Issuer",
        value: "ISSUER"
      },
      {
        label: "Acquirer",
        value: "ACQUIRER"
      },
      {
        label: "All",
        value: "ALL"
      }],
      createdFromDate: null,
      createdToDate: null,
      expiresFromDate: null,
      expiresToDate: null,
      transactionFromDate: null,
      transactionToDate: null,
      dateFilterChecked: true,
      searchButtonDisabled: true
    };

    this.onDisputeCategoryChange = this.onDisputeCategoryChange.bind(this);
    this.onDisputeSearchConcernChange = this.onDisputeSearchConcernChange.bind(this);
    this.onDisputeRegionChange = this.onDisputeRegionChange.bind(this);
    this.onDisputeStatusChange = this.onDisputeStatusChange.bind(this);
    this.onCreatedFromDateChange = this.onCreatedFromDateChange.bind(this);
    this.onExpiresFromDateChange = this.onExpiresFromDateChange.bind(this);
    this.onCreatedToDateChange = this.onCreatedToDateChange.bind(this);
    this.onExpiresToDateChange = this.onExpiresToDateChange.bind(this);
    this.onEnableDateFilterChange = this.onEnableDateFilterChange.bind(this);
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onAcquirerChange = this.onAcquirerChange.bind(this);
    this.onIssuerChange = this.onIssuerChange.bind(this);
    this.onMerchantChange = this.onMerchantChange.bind(this);
    this.onTransactionFromDateChange = this.onTransactionFromDateChange.bind(
      this
    );
    this.onTransactionToDateChange = this.onTransactionToDateChange.bind(this);
  }

  sortArrayOfObjects = arr => {
    if(arr && arr.length) {
      let newArr;
      newArr = arr.sort(function(a, b){
        if(a.label < b.label) { return -1; }
        if(a.label > b.label) { return 1; }
        return 0;
    })
    return newArr
    }
  }

  getDisputeMerchants = (cb) => {
    ArbiterApi.getDisputeMerchants()
      .then(response => {
        let merchants = [];
        Object.entries(response.data).forEach(
          ([key, value]) => merchants.push({label: value, value: key})
        );
        if(cb) cb();
        this.setState({ merchants });
      })
      .catch(error => {
        if(cb) cb();
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_MERCHANTS}`
        ]);
        console.log(error);
      });
  }
  getDisputeIssuers = (cb) => {
    ArbiterApi.getDisputeIssuers()
      .then(response => {
        let issuers = [];
        Object.entries(response.data).forEach(
          ([key, value]) => issuers.push({label: value, value: key})
        );
        if(cb) cb();
          issuers = this.sortArrayOfObjects(issuers)
        this.setState({ issuers });
      })
      .catch(error => {
        if(cb) cb();
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_ISSUERS}`
        ]);
        console.log(error);
      });
  }
  getDisputeRegions = (cb) => {
    ArbiterApi.getDisputeRegions()
      .then(response => {
        let regions = response.data.content.map(region => {
          return { value: region.name, label: region.name };
        });
        if(cb) cb();
        this.setState({ regions: regions });
      })
      .catch(error => {
        if(cb) cb();
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_DISPUTE_REGION}`
        ]);
        console.log(error);
      });
  }
  getDsputeAcquirers = (cb) => {
    ArbiterApi.getDisputeAcquirers()
      .then(response => {
        let acquirers = [];
        Object.entries(response.data).forEach(
          ([key, value]) => acquirers.push({label: value, value: key})
        );
        if(cb) cb()
        acquirers = this.sortArrayOfObjects(acquirers)
        this.setState({ acquirers });
      })
      .catch(error => {
        if(cb) cb()
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_ACQUIRERS}`
        ]);
        console.log(error);
      });
  }
  getDisputeCategories = (cb) => {
    ArbiterApi.getDisputeCategories()
      .then(response => {
        let categories = response.data.map(obj => {
          obj.label = obj.category;
          obj.value = obj.category;
          obj.statuses = obj.statuses.map(status => {
            return {
              label: status,
              value: status
            };
          });
          return obj;
        });
        if(cb) cb();
        this.setState({ categories });
      })
      .catch(error => {
        if(cb) cb()
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_DISPUTE_CATEGORIES}`
        ]);
        console.log(error);
      });
  }

  onTextInputChange(event) {
    let stateUpdate = {};
    stateUpdate[event.target.id] = event.target.value;
    this.setState(stateUpdate);
  }

  onCreatedFromDateChange(date) {
    this.setState({ createdFromDate: date });
  }
  onCreatedToDateChange(date) {
    this.setState({ createdToDate: date });
  }
  onExpiresFromDateChange(date) {
    this.setState({ expiresFromDate: date });
  }
  onExpiresToDateChange(date) {
    this.setState({ expiresToDate: date });
  }
  onEnableDateFilterChange(event) {
    this.setState({ dateFilterChecked: event.target.checked });
  }

  onTransactionFromDateChange(date) {
    this.setState({ transactionFromDate: date });
  }
  onTransactionToDateChange(date) {
    this.setState({ transactionToDate: date });
  }

  onSearchHandler() {
    //TODO: validate control values AND BUILD PARAMS

    //Build Params
    let params = {};
    if (this.state.logCode) params.logCode = this.state.logCode;
    if (this.state.region) params.region = this.state.region;
    if (this.state.status) params.status = this.state.status;
    if (this.state.category) params.category = this.state.category;
    if (this.state.region) params.region = this.state.region;
    if (this.state.accountNumber) params.accountNumber = this.state.accountNumber;
    if (this.state.maskedPan) params.maskedPan = this.state.maskedPan;
    if (this.state.acquirerCode) params.acquirerCode = this.state.acquirerCode;
    if (this.state.issuerCode) params.issuerCode = this.state.issuerCode;
    if (this.state.merchantCode) params.merchantCode = this.state.merchantCode;
    if(this.state.searchConcerns)params.searchConcerns = this.state.searchConcerns;

    if (this.state.createdFromDate)
      params.createdStartDate = this.state.createdFromDate
        .startOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);

    if (this.state.createdToDate)
      params.createdEndDate = this.state.createdToDate
        .endOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);

    if (this.state.expiresFromDate)
      params.expiryStartDate = this.state.expiresFromDate
        .startOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);
    if (this.state.expiresFromDate)
    params.expiryEndDate = this.state.expiresFromDate
      .endOf("day")
      .format(`${Constants.DATE_FORMAT_LONG}`);

    // if (this.state.expiresToDate)
    //   params.expiryEndDate = this.state.expiresToDate
    //     .endOf("day")
    //     .format(`${Constants.DATE_FORMAT_LONG}`);

    if (this.state.transactionFromDate)
      params.transactionStartDate = this.state.transactionFromDate
        .startOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);
    if (this.state.transactionToDate)
      params.transactionEndDate = this.state.transactionToDate
        .endOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);

    this.props.onSearchHandler && this.props.onSearchHandler(params, true);
  }
  onDisputeCategoryChange(event) {
    this.setState({
      category: event ? event.value : "",
      statuses: event ? event.statuses : []
    });
  }
  onDisputeRegionChange(event) {
    this.setState({
      region: event ? event.value : ""
    });
  }
  onIssuerChange(event) {
    this.setState({
      issuerCode: event ? event.value : ""
    });
  }

  onMerchantChange(event) {
    this.setState({
      merchantCode: event ? event.value : ""
    });
  }

  onAcquirerChange(event) {
    this.setState({
      acquirerCode: event ? event.value : ""
    });
  }
  onDisputeStatusChange(event) {
    this.setState({
      status: event ? event.value : ""
    });
  }
  onDisputeSearchConcernChange(event){
    this.setState({
      searchConcerns: event ? event.value : ""
    })
  }

  render() {
    return (
      <form
        onSubmit={e => {
          this.onSearchHandler();
          e.preventDefault();
          return false;
        }}
      >
        <div>
          <div className="row filters">
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-2">
                  <label className="input-control-label">Log Code</label>
                  <FloatInput
                    id="logCode"
                    value={this.state.logCode}
                    onChange={this.onTextInputChange}
                    placeholder="Log Code"
                  />
                </div>
                <div className="col-md-3" id="categoryColumn">
                  <label className="input-control-label">
                    Dispute Category
                  </label>

                  <SelectDropdown 
                    name="category"
                    placeholder="Dispute Category"
                    value={this.state.category}
                    options={this.state.categories}
                    onChange={this.onDisputeCategoryChange}
                    loadOptions={this.getDisputeCategories}
                  />
                </div>
                <div className=" col-md-2" id="statusColumn">
                  <label className="input-control-label">Dispute Status</label>
                  <Select
                    name="status"
                    placeholder="Dispute Status"
                    value={this.state.status}
                    options={this.state.statuses}
                    onChange={this.onDisputeStatusChange}
                  />

                </div>
                <div className=" col-md-3" id="regionColumn">
                  <label className="input-control-label">Dispute Region</label>
                 
                  <SelectDropdown
                    name="region"
                    placeholder="Dispute Region"
                    value={this.state.region}
                    options={this.state.regions}
                    onChange={this.onDisputeRegionChange}
                    loadOptions={this.getDisputeRegions}
                  />
                </div>
                 <div className="col-md-2">
                      <label className="input-control-label">Due date</label>
                   
                      <Datepicker
                        onChange={this.onExpiresFromDateChange}
                        className="form-control float_input"
                        id="expiresFromDate"
                        placeholderText="Due Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={
                          this.state.expiresToDate
                            ? this.state.expiresToDate
                            : null
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={this.state.expiresFromDate}
                      />
                    {/* </div> */}
                    {/* <div className="datepicker-container">
                      <Datepicker
                        onChange={this.onExpiresToDateChange}
                        className="form-control float_input"
                        id="expiresToDate"
                        placeholderText="To Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        minDate={
                          this.state.expiresFromDate
                            ? this.state.expiresFromDate.clone().add(1, "days")
                            : null
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={this.state.expiresToDate}
                      />
                    </div> */}
                  </div>
                
              </div>
            </div>
            <div className="col-md-2">
              <br />
              <button
                id="searchButton"
                className="btn btn-primary btn-block"
                type="submit"
              >
                Search
              </button>
            </div>
          </div>

          <div className="row filters">
            <div className="col-md-10">
              {this.state.dateFilterChecked && (
                <div className="row">
                  <div className="col-md-3">
                    <div>
                      <label>Pan</label>
                    </div>
                    <div className="datepicker-container">
                      <FloatInput
                        id="maskedPan"
                        value={this.state.maskedPan}
                        onChange={this.onTextInputChange}
                        placeholder="Pan"
                      />
                    </div>
                  </div>

                   <div className="col-md-3">
                    <div>
                      <label>Account Number</label>
                    </div>
                    <div className="datepicker-container">
                      <FloatInput
                        id="accountNumber"
                        value={this.state.accountNumber}
                        onChange={this.onTextInputChange}
                        placeholder="Account Number"
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div>
                      <label>Transaction Date</label>
                    </div>
                    <div className="datepicker-container">
                      <Datepicker
                        onChange={this.onTransactionFromDateChange}
                        className="form-control float_input"
                        id="transactionFromDate"
                        placeholderText="From Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={
                          this.state.transactionToDate
                            ? this.state.transactionToDate
                            : null
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={this.state.transactionFromDate}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div>
                      <label>Transaction Date</label>
                    </div>
                    <div className="datepicker-container">
                      <Datepicker
                        onChange={this.onTransactionToDateChange}
                        className="form-control float_input"
                        id="transactionToDate"
                        placeholderText="To Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        minDate={
                          this.state.transactionFromDate
                            ? this.state.transactionFromDate
                                .clone()
                                .add(1, "days")
                            : null
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={this.state.transactionToDate}
                      />
                    </div>
                  </div>
                  
                  {/* <div className=" col-md-2">
                    <div>
                      <label>Merchant</label>
                    </div>
                    <div className="datepicker-container">
                      {/* <Select
                        name="merchant"
                        placeholder="Merchant"
                        value={this.state.merchantCode}
                        options={this.state.merchants}
                        onChange={this.onMerchantChange}
                      /> */}
                      {/* <SelectDropdown
                        name="merchant"
                        placeholder="Merchant"
                        value={this.state.merchantCode}
                        options={this.state.merchants}
                        onChange={this.onMerchantChange}
                        loadOptions={this.getDisputeMerchants}
                      /> */}
                    {/* </div> */}
                  {/* </div> */}
                  
                

                  <div className="col-md-3">
                    <div>
                      <label>Issuer</label>
                    </div>
                    <div className="datepicker-container">
                      <SelectDropdown
                        name="issuer"
                        placeholder="Issuer"
                        value={this.state.issuerCode}
                        options={this.state.issuers}
                        onChange={this.onIssuerChange}
                        loadOptions={this.getDisputeIssuers}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div>
                      <label>Acquirer</label>
                    </div>
                    <div className="datepicker-container">
                      <SelectDropdown
                        name="acquirer"
                        placeholder="Acquirer"
                        value={this.state.acquirerCode}
                        options={this.state.acquirers}
                        onChange={this.onAcquirerChange}
                        loadOptions={this.getDsputeAcquirers}
                      />
                    </div>
                  </div>
                  
                  <div className="col-md-3">
                    <div>
                      <label>From Date</label>
                    </div>
                    <div className="datepicker-container">
                      <Datepicker
                        onChange={this.onCreatedFromDateChange}
                        className="form-control float_input"
                        id="createdFromDate"
                        placeholderText="From Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={
                          this.state.createdToDate
                            ? this.state.createdToDate
                            : null
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={this.state.createdFromDate}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div>
                      <label>To Date</label>
                    </div>
                    <div className="datepicker-container">
                      <Datepicker
                        onChange={this.onCreatedToDateChange}
                        className="form-control float_input"
                        id="createdToDate"
                        placeholderText="To Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        minDate={
                          this.state.createdFromDate
                            ? this.state.createdFromDate.clone().add(1, "days")
                            : null
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={this.state.createdToDate}
                      />
                    </div>
                  </div>
                 
                 
                </div>
              )}
            </div>
            <div className="col-md-2"  style={{ verticalAlign: "top" }}>
              <div style={{ textAlign: "right" }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      id="advancedCheckBox"
                      onChange={this.onEnableDateFilterChange}
                      defaultChecked={this.state.dateFilterChecked}
                    />
                    <span
                      className="lbl"
                      checked={this.state.dateFilterChecked}
                    >
                      Advanced Options
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(DisputesFilter, [Permissions.VIEW_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/disputesFilter.js